<section id="secao-previa-projeto">
  <div class="container py-5">
    <div class="row descricao">
      <div class="col-md-8">
        <div class="titulo">
          <h1 class="titulo">Projeto de Educere de Iniciação Tecnológico</h1>
        </div>
        <div class="texto">
          <p>
            Com o objetivo de despertar em adolescentes o interesse pela área de
            tecnologia, a Fundação Educere oferta gratuitamente um Projeto de
            iniciação à área de Pesquisa e Desenvolvimento (P&D), com ênfase em
            mecânica, programação e eletrônica.
          </p>
          <p>
            Além dessas disciplinas, os alunos recebem conteúdos de design de
            produto, programação, gestão, entre outras, sempre com foco no
            empreendedorismo e inovação.
          </p>
        </div>
        <button
          routerLink="/empreendedorismo-inovacao"
          type="button"
          class="btn btn-primary"
        >
          Saiba mais
        </button>
      </div>
      <div class="col-md-4 icone">
        <img src="assets/imagens/open-book.png" class="open-book" alt="" />
      </div>
    </div>
  </div>
</section>
